<template>
    <lq-el-form
        name="login"
        auto-complete="off"
        :rules="rules"
        action="login"
        @submited-error="submitedError"
        @submited-success="submitedSuccess"
    >
        <el-card shadow="always" :style="{overflow: 'initial'}">
            <lq-el-phone-or-text
                id="email"
                fetch-country
                :preferred-countries="['IN', 'SG']"
                placeholder="Email/Mobile No."
            />
            <lq-el-input id="password" type="password" placeholder="Password" />
            <el-row align="bottom" justify="end">
                <el-col :span="12">
                    <lq-el-submit label="Login" />
                </el-col>
                <el-col :span="12" align="right">
                    <div :style="{paddingTop: '5px'}">
                        <router-link :to="{ path: '/forget-password'}" class="link">Forgot Password</router-link>
                    </div>
                </el-col>
            </el-row>
        </el-card>
    </lq-el-form>
</template>
<script>
import { setTokens } from '@/utils/auth';
export default {
    name: 'login-form',
    // mixins:[lqForm],
    data: function() {
        return {
            rules: {
                email: {
                    presence: {
                        allowEmpty: false,
                        message: 'Email/Mobile no. field is required'
                    },
                    format: {
                        pattern: /(^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))|(^\+?([0-9]){1,4}?(\-)?([0-9 \s]){6,12}))/,
                        message: 'Please enter a valid email or mobile.'
                    }
                },
                password: {
                    presence: {
                        allowEmpty: false,
                        message: 'Password field is required'
                    }
                }
            }
        };
    },
    methods: {
        /**
         * When get error from the server.
         */
        submitedError: function(error) {
            const request_data = JSON.parse(error.config.data);

            if (error.response && error.response.data) {
                if (error.response.data.error_code === 'email_not_verified') {
                    this.dataVerificationPrompt(
                        request_data.email,
                        'Email Not Verified',
                        'Click on send button to get the verification link.',
                        'Mail has been send on your email (' +
                            request_data.email +
                            ').'
                    );
                } else if (
                    error.response.data.error_code === 'mobile_no_verified'
                ) {
                    this.dataVerificationPrompt(
                        request_data.email,
                        'Mobile Number Not Verified',
                        'Click on send button to get OTP.',
                        'SMS has been send on Mobile (' +
                            request_data.email +
                            ').'
                    );
                }
            }
        },

        /**
         * When login Success then store token and refresh token in cookie.
         */
        submitedSuccess: function(response) {
            const {
                profile: { role },
                device,
                token
            } = response.data;
            const landing_page = new URL(role.landing_page);
            const pathname = [landing_page.pathname, 'u', device.login_index]
                .join('/')
                .replaceAll(/^\/|\/$/g, '');
            setTokens(token, '/' + pathname.replaceAll(/^\/|\/$/g, ''));
            let url = [
                role.landing_page.replaceAll(/^\/|\/$/g, ''),
                'u',
                device.login_index
            ]
                .join('/')
                .replaceAll(/^\/|\/$/g, '');
            const landing_uri = this.$helper.getProp(
                role,
                'settings.landing_uri'
            );
            if (landing_uri) {
                url = url + '/' + landing_uri.replaceAll(/^\/|\/$/g, '');
            }
            window.location.href = url;
        },
        /**
         * To display the Dataverification prompt.
         */
        dataVerificationPrompt: function(
            email,
            title,
            message,
            success_message
        ) {
            this.$alert(message, title, {
                confirmButtonText: 'Send',
                showCancelButton: true,
                cancelButtonText: 'Cancel',
                beforeClose: (action, instance, done) => {
                    if (action === 'confirm') {
                        instance.confirmButtonLoading = true;
                        instance.confirmButtonText = 'Loading...';
                        this.axios
                            .post('data-verification-token', { email })
                            .then(() => {
                                instance.confirmButtonLoading = false;
                                instance.confirmButtonText = 'Send';

                                done();
                                this.$message({
                                    message: success_message,
                                    type: 'sucess'
                                });
                            })
                            .catch(() => {
                                instance.confirmButtonLoading = false;
                                instance.confirmButtonText = 'Send';
                                done();
                            });
                    } else {
                        done();
                    }
                },
                callback: action => {
                    this.promptToVerifyToken();
                }
            });
        },

        /**
         * To enter the token.
         */
        promptToVerifyToken: function() {
            this.$prompt('Please enter OTP/Token', 'Verify Email/Mobile', {
                confirmButtonText: 'OK',
                cancelButtonText: 'Cancel',
                beforeClose: (action, instance, done) => {
                    var token = instance.getInputElement().value;

                    if (action === 'confirm') {
                        if (!token) {
                            this.$message.error('Please enter the token.');
                            return;
                        }

                        instance.confirmButtonLoading = true;
                        instance.confirmButtonText = 'Loading...';
                        this.axios
                            .post('data-verify', { token })
                            .then(resposne => {
                                instance.confirmButtonLoading = false;

                                done();
                                this.$message({
                                    message:
                                        'Verification has been completed. Please try to login again.',
                                    type: 'sucess'
                                });
                            })
                            .catch(error => {
                                done();
                                instance.confirmButtonLoading = false;
                                this.$message.error(error.response.data.error);
                            });
                    } else {
                        done();
                    }
                }
            });
        }
    }
};
</script>
<style lang="sass">
    
</style>

